import { render, staticRenderFns } from "./transaction-detail.vue?vue&type=template&id=f26459bc&"
import script from "./transaction-detail.vue?vue&type=script&lang=js&"
export * from "./transaction-detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports